import { render, staticRenderFns } from "./createTemplate.vue?vue&type=template&id=4ff0038d&scoped=true&"
import script from "./createTemplate.vue?vue&type=script&lang=js&"
export * from "./createTemplate.vue?vue&type=script&lang=js&"
import style0 from "./createTemplate.vue?vue&type=style&index=0&id=4ff0038d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff0038d",
  null
  
)

export default component.exports